import '../styles/Projects.css';
import iNote1 from '../images/iNote/Capture.JPG';
import pawsAdoption from '../images/pawsAdoption/pawsAdoption.png';
import whiteBoard from '../images/whiteBoard/Capture.JPG';
import Dodge from '../images/DodgingTurtis/Dodging_Turtis.jpeg';
function Projects() {
  return (
    <div id='projects'>
      <br></br>

      <div className='project-container container'>
        <div className='row'>
          <div className='col-6 text-col '>
            <h4 class='title-font'>
              <b>Dodging Turtis</b>
            </h4>
            <p className='content-font'>
              A fun NFT based game made using ERC721
              <br />
              <span class='badge badge-info'>
                <b>ETHOdyssey Winner @Filecoin</b>
              </span>
              <span class='badge badge-primary'>ReactJS</span>
              <span class='badge badge-secondary'>Ethereum</span>
              <span class='badge badge-success'>Solidity</span>
              <span class='badge badge-danger'>IPFS</span>
              <span class='badge badge-warning'>Polygon</span>
              <span class='badge badge-info'>NFT Storage</span>
            </p>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <a href='https://devfolio.co/submissions/dodging-turtis-01a4'>
              <b>Read more</b>
            </a>

            <div className='box-style-4 container-fluid'></div>
          </div>

          <div class='col-6 img-div'>
            <a href='https://devfolio.co/submissions/dodging-turtis-01a4'>
              <img className='img-iNote' alt='#' src={Dodge} />
            </a>
          </div>
        </div>
      </div>

      <div className='project-container container'>
        <div className='row'>
          <div class='col-6 img-div'>
            <a href='https://github.com/Hardikag17/iNote'>
              <img className='img-iNote' alt='#' src={iNote1} />
            </a>
          </div>

          <div className='col-6 text-col'>
            <h4 class='title-font'>
              <b>iNote</b>
            </h4>
            <p className='content-font'>
              This website is a secured WEB notepad which stores all the user
              data securily in server side. It uses JWT tokens in backend and
              HTTPOnly cookies in client side to make user authentication
              secured.
              <br />
              <span class='badge badge-primary'>ReactJS</span>
              <span class='badge badge-secondary'>NodeJS</span>
              <span class='badge badge-info'>Express JS</span>
              <span class='badge badge-success'>Mongodb</span>
              <span class='badge badge-danger'>REST API</span>
              <span class='badge badge-warning'>JWT</span>
            </p>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <a href='https://github.com/Hardikag17/iNote'>
              <b>Read more</b>
            </a>
            <div className='box-style-1 container-fluid'></div>
          </div>
        </div>
      </div>

      <div className='project-container container'>
        <div className='row'>
          <div className='col-6 text-col'>
            <h4 class='title-font'>
              <b>Paws Adoption</b>
            </h4>
            <p className='content-font'>
              A website to connect stray animals with willing adopters build
              during the hackathon "hack the space" by Team DNA. It uses
              react.js for frontend and flask for backend.
              <br />
              <span class='badge badge-primary'>ReactJS</span>
              <span class='badge badge-secondary'>REST API</span>
            </p>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <a href='https://github.com/Hardikag17/PawsAdoption'>
              <b>Read more</b>
            </a>
            <div className='box-style-2 container-fluid'></div>
          </div>

          <div class='col-6 img-div'>
            <a href='https://github.com/Hardikag17/PawsAdoption'>
              <img className='img-iNote' alt='#' src={pawsAdoption} />
            </a>
          </div>
        </div>
      </div>

      <div className='project-container container'>
        <div className='row'>
          <div class='col-6 img-div'>
            <a href='https://github.com/Hardikag17/whiteBoard'>
              <img className='img-iNote' alt='#' src={whiteBoard} />
            </a>
          </div>

          <div className='col-6 text-col '>
            <h4 class='title-font'>
              <b>WhiteBoard</b>
            </h4>
            <p className='content-font'>
              A sleek and simple HTML 5 based WhiteBoard web App made using
              vanilla javascript.
              <br />
              <span class='badge badge-primary'>Html5</span>
              <span class='badge badge-secondary'>Vallina JavaScript</span>
              <span class='badge badge-success'>Html5 canvas</span>
            </p>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <a href='https://github.com/Hardikag17/whiteBoard'>
              <b>Read more</b>
            </a>

            <div className='box-style-3 container-fluid'></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
